export default __webpack_public_path__ + "static/media/IMG_0187.dd79beb9.JPG";